import axios from '@/utils/request';

const STORAGE_KEY = 'uiTexts';
const PORT_STORAGE_KEY = 'lastPortCode';

const DEFAULT_TEXTS = {
  'app.h5.title': '梯口卫士管理系统',
  'login.page.title': '闸口通管理系统',
  'login.page.subtitle': '请输入账号信息，进入闸口通行管理中心',
  'login.form.usernameLabel': '用户名',
  'login.form.usernamePlaceholder': '请输入用户名',
  'login.form.passwordLabel': '密码',
  'login.form.passwordPlaceholder': '请输入密码',
  'login.form.captchaLabel': '验证码',
  'login.form.captchaPlaceholder': '请输入验证码',
  'login.button.submit': '登录系统',
  'home.sidebar.brandTitle': '梯口卫士',
  'home.sidebar.brandDesc': '船舶与人员通行管理平台',
  'home.sidebar.onlineStatus': '系统在线运行中',
  'home.nav.logout': '退出',
  'home.logout.confirmTitle': '确认退出',
  'home.logout.confirmMessage': '您确定要退出系统吗？',
  'home.logout.success': '已退出系统',
  'home.default.pageTitle': '船舶管理系统',
  'nav.page.shipBinding': '航次绑定',
  'nav.page.passRecord': '通行记录',
  'nav.page.fenceAlarm': '报警信息',
  'nav.page.statistics': '数据统计',
  'nav.page.deviceManagement': '设备管理',
  'nav.page.userManagement': '用户管理',
  'nav.page.permanentPersonnel': '常备人员',
  'nav.page.domesticCrew': '内贸船员',
  'nav.page.vehicleDeparture': '车辆离场',
  'nav.page.accessRegistration': '出入登记',
  'nav.page.accessRecords': '登记记录',
  'nav.page.accessRegistrationPersonIn': '人员入场登记',
  'nav.page.accessRegistrationPersonOut': '人员离场登记',
  'nav.page.accessRegistrationVehicleIn': '车辆入场登记',
  'nav.page.accessRegistrationVehicleOut': '车辆离场登记',
  'nav.page.accessRegistrationCrewLuggageIn': '携带行李入闸登记',
  'nav.page.accessRegistrationCrewLuggageOut': '携带行李出闸登记',
  'nav.page.accessRegistrationCrewNoLuggageIn': '无行李入闸登记',
  'nav.page.accessRegistrationCrewNoLuggageOut': '无行李出闸登记',
  'nav.page.liveTest': '直播测试',
  'nav.page.permissionManagement': '权限管理',
  'passRecord.search.docNoPlaceholder': '输入证件号码搜索',
  'passRecord.search.button': '搜索',
  'passRecord.filter.dateLabel': '日期范围',
  'passRecord.filter.datePlaceholder': '选择日期范围',
  'passRecord.filter.deviceLabel': '闸口设备',
  'passRecord.filter.devicePlaceholder': '选择闸口设备',
  'passRecord.datePicker.startLabel': '开始日期',
  'passRecord.datePicker.endLabel': '结束日期',
  'passRecord.datePicker.cancel': '取消',
  'passRecord.datePicker.confirm': '确定',
  'passRecord.devicePopup.title': '选择梯口设备',
  'passRecord.devicePopup.availableListTitle': '可用梯口设备列表',
  'passRecord.devicePopup.loading': '加载设备中...',
  'passRecord.devicePopup.empty': '暂无可用梯口设备',
  'passRecord.devicePopup.confirm': '确定选择',
  'passRecord.stat.total': '总记录数',
  'passRecord.stat.boardCount': '入场数',
  'passRecord.stat.leaveCount': '离场数',
  'passRecord.empty': '暂无通行记录',
  'passRecord.detail.title': '通行详情',
  'statistics.toolbar.refresh': '刷新数据',
  'statistics.card.boarding': '登船人员',
  'statistics.card.disembarking': '离船人员',
  'statistics.card.permanent': '常备人员',
  'statistics.card.visitor': '访客数量',
  'statistics.card.abnormal': '异常通行',
  'statistics.card.loginCount': '系统登录次数',
  'statistics.card.assistant': '协管员',
  'statistics.card.temporary': '临时人员',
  'statistics.card.sailor': '船员数量',
  'statistics.trend.title': '通行趋势',
  'statistics.trend.subtitle': '按时间范围查看登船与离船走势',
  'statistics.trend.switchToBar': '柱状图',
  'statistics.trend.switchToLine': '折线图',
  'statistics.quick.title': '关键指标',
  'statistics.quick.subtitle': '当前核心运行状态'
};

const uiTextStore = {
  loaded: false,
  portCode: '',
  texts: { ...DEFAULT_TEXTS }
};

function safeParse(jsonText, fallback) {
  try {
    return JSON.parse(jsonText);
  } catch (error) {
    return fallback;
  }
}

function persistUiTexts() {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(uiTextStore.texts));
  if (uiTextStore.portCode) {
    localStorage.setItem(PORT_STORAGE_KEY, uiTextStore.portCode);
  }
}

export function setDocumentTitle(title) {
  document.title = title || DEFAULT_TEXTS['app.h5.title'];
}

export function hydrateUiTextsFromStorage() {
  const cachedTexts = safeParse(localStorage.getItem(STORAGE_KEY) || '{}', {});
  uiTextStore.texts = {
    ...DEFAULT_TEXTS,
    ...cachedTexts
  };
  uiTextStore.portCode = localStorage.getItem(PORT_STORAGE_KEY) || '';
  uiTextStore.loaded = true;
  setDocumentTitle(uiTextStore.texts['app.h5.title']);
  return uiTextStore;
}

export function t(key, fallback = '') {
  if (!key) {
    return fallback;
  }

  return uiTextStore.texts[key] || fallback;
}

export async function loadUiTexts(portCode = '') {
  const normalizedPortCode = (portCode || '').trim();
  const response = await axios.get('/api/UiTextConfig/GetByPort', {
    params: normalizedPortCode ? { portCode: normalizedPortCode } : {}
  });

  if (response && response.data && response.data.success) {
    uiTextStore.texts = {
      ...DEFAULT_TEXTS,
      ...(response.data.data || {})
    };
    uiTextStore.portCode = normalizedPortCode;
    uiTextStore.loaded = true;
    persistUiTexts();
    setDocumentTitle(uiTextStore.texts['app.h5.title']);
    return uiTextStore.texts;
  }

  throw new Error((response && response.data && response.data.message) || '加载页面文案失败');
}

export async function initializeUiTexts() {
  hydrateUiTextsFromStorage();

  try {
    await loadUiTexts(uiTextStore.portCode);
  } catch (error) {
    setDocumentTitle(uiTextStore.texts['app.h5.title']);
  }

  return uiTextStore;
}

export default uiTextStore;
